import { useEffect, useState } from "react";
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { emtSocket } from "../../../../CommonFunction/SocketClient";
import Button from "../../Button/Button";
import { ErrorToast, SuccessToast } from "../../ToastComponent/RectHotToast";
import CnfModal from "../AllModals/CnfModal/CnfModal";
import "./CreateButton.scss";
import Input from "../../Input/Input";
import Reactportal from "../../Reactportal/Reactportal";



const EDIT_BID_DETAILS = gql`
mutation editBidDetails($id: ID!,$BidId:ID, $userInput: TripBookingsInput!){
  editBidDetails(id:$id,BidId:$BidId,userInput:$userInput)
  {
    _id
    LoadId
  }
}
`

const DATA_BY_PINCODE = gql`
query Pincode($pincode: String!) {
  pincode(pincode: $pincode) {
    Pincode
    State
    City
    District
    Towns
  }
}
`


function CreateButton({ el, confirm, finalNoOfVehicleRequired }) {
  const [place, setPlace] = useState({
    Loading_Pincode: "",
    Loading_City: "",
    Loading_State: "",
    Unloading_Pincode: "",
    Unloading_City: "",
    Unloading_State: "",
  })
  const [tripManage, setTripManage] = useState(false)
  const [openVehicleCnfModal, setOpenVehicleCnfModal] = useState(false);
  const [editCommittedVehiclesId, setEditCommittedVehiclesId] = useState();
  const [iseditCommittedVehiclesLoading, setIsEditCommittedVehiclesLoading] = useState(false);
  const [edittBidDetails, { loading: editCommittedVehiclesLoading }] = useMutation(
    EDIT_BID_DETAILS, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  }

  );

  const [getDataByPincode] = useLazyQuery(DATA_BY_PINCODE, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  })
  const [btnStatus, setBtnStatus] = useState(false);
 
  async function editCommittedVehiclesData() {
    await edittBidDetails({
      variables: {
        id: el?._id,
        BidId: el.Bids[editCommittedVehiclesId]._id,
        userInput: {
          Is_Confirmed: true,
          Trip_Management: tripManage,
          ...place
        },
      },
    })
      .then((res) => {
       
        // emtSocket.emit("EditConfirmVechileswithId", res.data.editBidDetails.LoadId);
        SuccessToast("Vehicle Confirmed");
        setOpenVehicleCnfModal(false);
      })
      .catch((err) => ErrorToast(err.message));
  }

  function getBtnText(Is_Accepted, Is_Rejected) {
    if (Is_Accepted) {
      return <>Accepted</>;
    } else if (Is_Rejected) {
      return <>Rejected</>;
    }
    return <>Confirmed</>;
  }
  const GetCityAndState = (e) => {
    let name = e.target.name
    let pin = e.target.value
    getDataByPincode({
      variables: {
        pincode: String(pin)
      }
    }).then(({ data }) => {
     
      setPlace({
        ...place, [name]: pin, [name == "Loading_Pincode" ? "Loading_City" : "Unloading_City"]: data.pincode[0].City,
        [name == "Loading_Pincode" ? "Loading_State" : "Unloading_State"]: data.pincode[0].State

      })
    })
  }
 
  useEffect(() => {
    if (finalNoOfVehicleRequired === 0) {
      setBtnStatus(true);
    } else {
      setBtnStatus(false);
    }
  }, [finalNoOfVehicleRequired]);

  useEffect(() => {
    setIsEditCommittedVehiclesLoading(editCommittedVehiclesLoading);
  }, [editCommittedVehiclesLoading]);

  return (
    <>
      <div className="btnDivision">
        {el &&
          el.Bids?.map((el, i) => {
            return (
              <Button
                key={el && el.id}
                name="modalbutton"
                text={el && el.Is_Confirmed ? getBtnText(el.Is_Accepted, el.Is_Rejected) : "Confirm"}
                className={(el && el.Is_Confirmed) || el?.Time_Out_Expired || btnStatus ? "cnfDisabledBtn" : "cnfBtn"}
                disabled={(el && el.Is_Confirmed) || el?.Time_Out_Expired || btnStatus ? true : false}
                action={() => {
                  setOpenVehicleCnfModal(true);
                  setEditCommittedVehiclesId(i);
                }}
              />
            );
          })}
      </div>
      <Reactportal
        open={openVehicleCnfModal}
        onClose={() => setOpenVehicleCnfModal(false)}
        modalClassName="confirmationModal"
        contentClassName="confirmationModal-content"
        modalHeading={"Confirmation"}
      >
        <CnfModal
          onClose={() => setOpenVehicleCnfModal(false)}
          cnfMessage={<>Do you want to confirm this vehicle?
            <div className="manageTripCont" >
              <p>Do you want to manage Trip?</p>
              <input value={tripManage} onChange={(e) => setTripManage(e.target.checked)} type={"checkbox"} />
            </div>
            {
              tripManage && <div className="inpCont">

                <Input type={'number'} modalform={true} handleBlur={() => { }}
                  handleInputChange={(e) => {
                    let value = String(e.target.value)
                    if (value.length == 6) {
                      GetCityAndState(e)
                    }

                  }}
                  name="Loading_Pincode" />
                <Input type={'number'} modalform={true} handleBlur={() => { }} handleInputChange={(e) => {
                  let value = String(e.target.value)
                  if (value.length == 6) {
                    GetCityAndState(e)
                  }

                }} name="Unloading_Pincode" />
              </div>
            }
          </>}
          editCommittedVehiclesData={editCommittedVehiclesData}
          loading={iseditCommittedVehiclesLoading}
        />
      </Reactportal>
    </>
  );
}

export default CreateButton;
